import { useProfilForm } from "../hooks/use-profil-form";
import { ProfilFormFields } from "./profil-form-fields";

interface EditProfilFormProps {
  id: string;
  onCancel: () => void;
  onSuccess: () => void;
}

export function EditProfilForm({ id, onCancel, onSuccess }: EditProfilFormProps) {
  const {
    formData,
    error,
    droitOptions,
    isEditing,
    isLoading,
    isLoadingDroits,
    isPending,
    handleInputChange,
    handleSelectChange,
    handleCheckboxChange,
    handleSubmit,
  } = useProfilForm({ id, onSuccess });

  if (isLoading) {
    return <div className="flex justify-center p-4">Chargement des données...</div>;
  }

  return (
    <ProfilFormFields
      formData={formData}
      error={error}
      droitOptions={droitOptions}
      isEditing={isEditing}
      isLoadingDroits={isLoadingDroits}
      isPending={isPending}
      onCancel={onCancel}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      handleCheckboxChange={handleCheckboxChange}
      handleSubmit={handleSubmit}
    />
  );
}
